
export default () => {
  return (
    <div className="menu">
      <NavLink
        to={'/'}
        className={({ isActive }) => (isActive ? 'active' : '')}
      >
        
        Schedule
      </NavLink>
      <NavLink
        to={'/birl'}
        className={({ isActive }) => (isActive ? 'active' : '')}
      >
        
        Birl
      </NavLink>
      <NavLink
        to={'/dodoables'}
        className={({ isActive }) => (isActive ? 'active' : '')}
      >
        
        Dodoables
      </NavLink>
    </div>
  )
}
